import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ModalService, ConfirmationModalComponent } from '../../shared/modules/modal';
import { TransactionsService, NotificationService } from '../../shared/services';

import {
  EvaluateServiceTransaction,
  EvaluateServiceTransactionErrorResponse,
  Message,
  EvaluateServiceTransactionModalPayload } from '../../shared/models';

import {
  ClosableModalWithErrorResponseModel
} from '../../shared/components/base/closable-modal-with-error-response-model';

import { TinyTextEditor, TranslationConstants } from '../../shared/constants';

@Component({
  selector: 'evaluate-service-transaction',
  templateUrl: './evaluate-service-transaction.component.html',
})
export class EvaluateServiceTransactionComponent
  extends ClosableModalWithErrorResponseModel<EvaluateServiceTransactionErrorResponse> implements OnInit, OnDestroy {

  data: EvaluateServiceTransactionModalPayload;
  serviceTransactionEvaluation = new EvaluateServiceTransaction();
  sourceJurisdiction: string;
  destinationJurisdiction: string;

  tinyInit = TinyTextEditor.INIT;

  constructor(
    protected modalService: ModalService,
    protected notificationService: NotificationService,
    protected transactionsService: TransactionsService
  ) {
    super(notificationService, modalService);
    this.validationErrors = new EvaluateServiceTransactionErrorResponse();
  }

  ngOnInit() {
    this.serviceTransactionEvaluation.transaction.transactionId = this.data.transaction.transactionId;

    this.setSourceAndDestinationJurisdictions();
    this.getServiceTransactionEvaluation();

    this.listenForErrorMessages();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  close(form = null): void {
    if (form && form.form.touched) {
      this.modalService.openModal({
        component: ConfirmationModalComponent,
        data: {
          title: TranslationConstants.CLOSE_SERVICE_EVALUATION,
          content: TranslationConstants.GLOBAL_CANCEL_MODAL_MESSAGE,
        } as Message,
        success: () => {
          this.closeAllModals();
        },
      });
    } else {
      this.closeAllModals();
    }
  }

  save(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    const destComplete = this.serviceTransactionEvaluation.isDestinationComplete;
    const sourceComplete = this.serviceTransactionEvaluation.isSourceComplete;
    this.serviceTransactionEvaluation.isDestinationComplete = destComplete === null || destComplete === undefined ? false : destComplete;
    this.serviceTransactionEvaluation.isSourceComplete = sourceComplete === null || sourceComplete === undefined ? false : sourceComplete;

    this.transactionsService.saveServiceTransactionEvaluation(
      this.data.transaction.transactionId,
      this.serviceTransactionEvaluation
    ).subscribe(() => {
      this.success();
      this.close();
    });
  }

  markFormAsTouched(form: NgForm): void { // TODO: make a util for this
    form.form.markAsTouched();
  }

  private getServiceTransactionEvaluation(): void {
    this.transactionsService.getServiceTransactionEvaluation(this.data.transaction.transactionId).subscribe((res) => {
      Object.assign(this.serviceTransactionEvaluation, res.result);
    });
  }

  private setSourceAndDestinationJurisdictions(): void {
    const sourceEntityTransaction = this.data.transaction.legalEntityTransactions.find(legalEntityTransaction => legalEntityTransaction.isSource);
    const destinationEntityTransaction = this.data.transaction.legalEntityTransactions.find(legalEntityTransaction => !legalEntityTransaction.isSource);
    if (sourceEntityTransaction && sourceEntityTransaction.entity && sourceEntityTransaction.entity.taxJurisdiction && sourceEntityTransaction.entity.taxJurisdiction.isoCode) {
      this.sourceJurisdiction = sourceEntityTransaction.entity.taxJurisdiction.isoCode;
    }
    if (destinationEntityTransaction && destinationEntityTransaction.entity && destinationEntityTransaction.entity.taxJurisdiction && destinationEntityTransaction.entity.taxJurisdiction.isoCode) {
      this.destinationJurisdiction = destinationEntityTransaction.entity.taxJurisdiction.isoCode;
    }
  }

}
